import { useAuthStore } from '../stores/authStore';
import { useNavigate } from 'react-router-dom';

interface TopBarProps {
  onMenuToggle?: () => void;
}

export default function TopBar({ onMenuToggle }: TopBarProps) {
  const { user, logout } = useAuthStore();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <header className="h-12 bg-white border-b border-gray-200 flex items-center justify-between px-3 md:px-5">
      <div className="flex items-center gap-3">
        {/* Hamburger - mobile only */}
        <button
          onClick={onMenuToggle}
          className="md:hidden p-1 -ml-1 text-gray-600 hover:text-gray-900"
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </button>
        <span className="w-2 h-2 rounded-full bg-emerald-500" />
        <span className="text-[10px] font-mono tracking-[0.15em] text-gray-400 hidden sm:inline">ONLINE</span>
      </div>
      <div className="flex items-center gap-4">
        <span className="text-xs font-mono text-gray-600">
          {user?.first_name}
          <span className="hidden sm:inline"> {user?.last_name}</span>
          <span className="ml-2 text-[10px] bg-gray-100 text-gray-500 px-2 py-0.5 rounded border border-gray-200">
            {user?.role?.toUpperCase()}
          </span>
        </span>
        <button
          onClick={handleLogout}
          className="text-[10px] font-mono tracking-wider text-gray-400 hover:text-red-500 transition-colors"
        >
          Log out
        </button>
      </div>
    </header>
  );
}
